import { UploadResult } from 'runtime/data/uploadresult';

export class CropRequested {
    static eventName() { return 'CropRequested'; }
    eventName = CropRequested.eventName;

    constructor(public fileId: string, public workItemId: string, public imageWidth: number, public imageHeight: number,
        public x: number, public y: number, public width: number, public height: number, public callback: (x: UploadResult) => void) { }
}
